import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Notify from "../components/Notify";
import UsersView from "./UsersView";

export default class ProfileView extends BaseView {
    init() {
        super.init();
        let self = this;
        if ($("#profile").length > 0) {
            let id = $('#profile').data('id');
            self.renderForm(id);

        }
    }

    renderForm(id) {
        let self = this;
        Api.send(`/api/users/${id}`, {}, 'get').done(function (result) {
            Api.getTpl('profile-form').done(function (r) {
                const tpl = _.template(r);
                $('#profile').append(tpl({profile: result}));

                $('input[name="password"]').pwstrength({
                    ui: {showVerdictsInsideProgressBar: true}
                });

                self.setEvent();
            });
        });
    }

    setEvent() {
        $('.save').off("click.patha").on("click.patha", function () {
            const form = $('#profileform');
            const data = form.aeroSerialize();
            let id = $('#profile').data('id');
            if (UsersView.validate(form)) {
                Api.send(`/api/users/${id}`, data, 'patch').done(function () {
                    Notify(Lang.success, 'success', 600);
                });
            }
        });
        $('.cancel').off("click.patha").on("click.patha", function () {
            history.go(-1);
            return false;
        });
    }

}
